module.exports = __webpack_public_path__ + "static/media/screen-location-upperright.f049bcab.svg";